import { Checkbox } from "./ui/checkbox";

export default function UserMultiSelect({ users = [], value = [], onChange, emptyText = "No hay usuarios disponibles." }) {
    const selected = value || [];
    const toggle = (userId) => {
        onChange?.(
            selected.includes(userId)
                ? selected.filter((id) => id !== userId)
                : [...selected, userId]
        );
    };

    return (
        <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3 max-h-40 overflow-y-auto rounded-md border border-slate-200 p-3">
            {users.map((person) => (
                <label key={person.user_id} className="flex cursor-pointer items-center gap-2 text-sm text-slate-700">
                    <Checkbox checked={selected.includes(person.user_id)} onCheckedChange={() => toggle(person.user_id)} />
                    <span className="truncate">
                        {person.name}
                        <span className="ml-1 text-xs text-slate-400">({person.role})</span>
                    </span>
                </label>
            ))}
            {users.length === 0 && <p className="text-sm text-slate-400">{emptyText}</p>}
        </div>
    );
}
